import React, { useEffect, useState } from "react";
import { useDebouncedValue } from "@/hooks/useDebouncedValue";
import SearchInput from "@/components/SearchInput/SearchInput";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { StageStatusFilter } from "../../api/getStages/types";

interface StageFiltersProps {
  searchTerm: string;
  status: StageStatusFilter;
  onSearchChange: (value: string) => void;
  onStatusChange: (status: StageStatusFilter) => void;
}

const StageFilters: React.FC<StageFiltersProps> = ({
  searchTerm,
  status,
  onSearchChange,
  onStatusChange,
}) => {
  const [searchInput, setSearchInput] = useState(searchTerm);
  const debouncedSearch = useDebouncedValue(searchInput, 500);

  useEffect(() => {
    if (debouncedSearch !== searchTerm) {
      onSearchChange(debouncedSearch);
    }
  }, [debouncedSearch, searchTerm, onSearchChange]);

  return (
    <div className="mb-4 flex items-center gap-3">
      <SearchInput
        className="max-w-md"
        onChange={setSearchInput}
        placeholder="Search by name"
        value={searchInput}
      />
      <Select
        onValueChange={(value) => onStatusChange(value as StageStatusFilter)}
        value={status}
      >
        <SelectTrigger className="w-[140px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All</SelectItem>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="inactive">Inactive</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default StageFilters;
